import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { MenuItem, Select } from '@mui/material';

export default function TimePicker({ selectedTime, onChange, disableTimeArray }) {
  const ticks = useMemo(() => {
    const startOfDayDate = moment().startOf('day');
    return new Array(12).fill().reduce(
      (acc, _, index) => [
        ...acc,
        ...Array(1)
          .fill()
          .map(() => moment(startOfDayDate).add(index, 'hour')),
        ...Array(1)
          .fill()
          .map(() => moment(startOfDayDate).add(index, 'hour').add(15, 'minute')),
        ...Array(1)
          .fill()
          .map(() => moment(startOfDayDate).add(index, 'hour').add(30, 'minute')),
        ...Array(1)
          .fill()
          .map(() => moment(startOfDayDate).add(index, 'hour').add(45, 'minute'))
      ],
      []
    );
  }, []);
  return (
    <Select
      size="small"
      sx={{
        '.MuiInputBase-input': {
          paddingRight: '14px !important'
        },
        '.MuiOutlinedInput-notchedOutline': {
          borderRight: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0
        }
      }}
      value={moment(selectedTime).format('h:mm')}
      onChange={(v) => {
        const date = ticks.find((t) => moment(t).format('h:mm') === v.target.value);
        onChange(moment(date).toISOString());
      }}
      MenuProps={{
        PaperProps: {
          style: {
            maxHeight: 48 * 4.5 + 8
          }
        }
      }}
      IconComponent={() => null}
    >
      {ticks.map((t, index) => (
        <MenuItem
          disabled={
            disableTimeArray.filter((dt) => moment(dt).format('h:mm') === moment(t).format('h:mm'))
              .length > 0
          }
          key={index}
          value={moment(t).format('h:mm')}
        >
          {moment(t).format('h:mm')}
        </MenuItem>
      ))}
    </Select>
  );
}

TimePicker.propTypes = {
  selectedTime: PropTypes.string,
  onChange: PropTypes.func,
  disableTimeArray: PropTypes.array
};
